/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddProductDto } from '../models/add-product-dto';
import { CohortTypeEnum } from '../models/cohort-type-enum';
import { InsightBucketEnum } from '../models/insight-bucket-enum';
import { InsightDto } from '../models/insight-dto';
import { InsightIdEnum } from '../models/insight-id-enum';
import { TechStackDto } from '../models/tech-stack-dto';
import { TechStackRefDto } from '../models/tech-stack-ref-dto';
import { TechStackTemplateDto } from '../models/tech-stack-template-dto';

@Injectable({
  providedIn: 'root',
})
export class TechStackService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation buildTechStackByTemplate
   */
  static readonly BuildTechStackByTemplatePath = '/techstacks/build';

  /**
   * Build Tech Stack By Template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildTechStackByTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildTechStackByTemplate$Response(params: {
    body: TechStackTemplateDto
  }): Observable<StrictHttpResponse<TechStackDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.BuildTechStackByTemplatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackDto>;
      })
    );
  }

  /**
   * Build Tech Stack By Template.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `buildTechStackByTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildTechStackByTemplate(params: {
    body: TechStackTemplateDto
  }): Observable<TechStackDto> {

    return this.buildTechStackByTemplate$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackDto>) => r.body as TechStackDto)
    );
  }

  /**
   * Path part for operation buildTechStack
   */
  static readonly BuildTechStackPath = '/techstacks/type/{type}';

  /**
   * Build Tech Stack.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildTechStack()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildTechStack$Response(params: {
    type: string;
    cohort?: CohortTypeEnum;
  }): Observable<StrictHttpResponse<TechStackDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.BuildTechStackPath, 'get');
    if (params) {
      rb.path('type', params.type, {});
      rb.query('cohort', params.cohort, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackDto>;
      })
    );
  }

  /**
   * Build Tech Stack.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `buildTechStack$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildTechStack(params: {
    type: string;
    cohort?: CohortTypeEnum;
  }): Observable<TechStackDto> {

    return this.buildTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackDto>) => r.body as TechStackDto)
    );
  }

  /**
   * Path part for operation buildTechStackById
   */
  static readonly BuildTechStackByIdPath = '/techstacks/build-by-id/{id}';

  /**
   * Build tech stack by another tech stack id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildTechStackById()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildTechStackById$Response(params: {
    id: string;
    cohort?: CohortTypeEnum;
  }): Observable<StrictHttpResponse<TechStackDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.BuildTechStackByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('cohort', params.cohort, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackDto>;
      })
    );
  }

  /**
   * Build tech stack by another tech stack id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `buildTechStackById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildTechStackById(params: {
    id: string;
    cohort?: CohortTypeEnum;
  }): Observable<TechStackDto> {

    return this.buildTechStackById$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackDto>) => r.body as TechStackDto)
    );
  }

  /**
   * Path part for operation getTechStacks
   */
  static readonly GetTechStacksPath = '/techstacks';

  /**
   * Get Tech Stacks regardless of materialized or not.
   *
   * Returns a list of techstacks both materialized and not. If id is empty then techstack is not materialized and must be built by type, otherwise it can be loaded by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStacks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStacks$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TechStackRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetTechStacksPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TechStackRefDto>>;
      })
    );
  }

  /**
   * Get Tech Stacks regardless of materialized or not.
   *
   * Returns a list of techstacks both materialized and not. If id is empty then techstack is not materialized and must be built by type, otherwise it can be loaded by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStacks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStacks(params?: {
  }): Observable<Array<TechStackRefDto>> {

    return this.getTechStacks$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TechStackRefDto>>) => r.body as Array<TechStackRefDto>)
    );
  }

  /**
   * Path part for operation createTechStack
   */
  static readonly CreateTechStackPath = '/techstacks';

  /**
   * Create Tech Stack.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTechStack()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTechStack$Response(params: {
    body: TechStackDto
  }): Observable<StrictHttpResponse<{
'id'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.CreateTechStackPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'id'?: string;
        }>;
      })
    );
  }

  /**
   * Create Tech Stack.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTechStack$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTechStack(params: {
    body: TechStackDto
  }): Observable<{
'id'?: string;
}> {

    return this.createTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<{
'id'?: string;
}>) => r.body as {
'id'?: string;
})
    );
  }

  /**
   * Path part for operation getTechStack
   */
  static readonly GetTechStackPath = '/techstacks/{id}';

  /**
   * Get Tech Stack.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStack()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStack$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<TechStackDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetTechStackPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackDto>;
      })
    );
  }

  /**
   * Get Tech Stack.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStack$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStack(params: {
    id: string;
  }): Observable<TechStackDto> {

    return this.getTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackDto>) => r.body as TechStackDto)
    );
  }

  /**
   * Path part for operation updateTechStack
   */
  static readonly UpdateTechStackPath = '/techstacks/{id}';

  /**
   * Update Tech Stack.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTechStack()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTechStack$Response(params: {
    id: string;
    body: TechStackDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.UpdateTechStackPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update Tech Stack.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTechStack$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTechStack(params: {
    id: string;
    body: TechStackDto
  }): Observable<void> {

    return this.updateTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteTechStack
   */
  static readonly DeleteTechStackPath = '/techstacks/{id}';

  /**
   * Delete Tech Stack and clear all changes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTechStack()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTechStack$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.DeleteTechStackPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete Tech Stack and clear all changes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTechStack$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTechStack(params: {
    id: string;
  }): Observable<void> {

    return this.deleteTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getTechStackInsights
   */
  static readonly GetTechStackInsightsPath = '/techstacks/{id}/insights';

  /**
   * Get Tech Stack Insights.
   *
   * Please, use POST /insights instead
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStackInsights()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTechStackInsights$Response(params: {
    id: string;
    cohort: CohortTypeEnum;
    bucket?: InsightBucketEnum;
    insightId?: InsightIdEnum;
  }): Observable<StrictHttpResponse<Array<InsightDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetTechStackInsightsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('cohort', params.cohort, {});
      rb.query('bucket', params.bucket, {});
      rb.query('insightId', params.insightId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InsightDto>>;
      })
    );
  }

  /**
   * Get Tech Stack Insights.
   *
   * Please, use POST /insights instead
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStackInsights$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTechStackInsights(params: {
    id: string;
    cohort: CohortTypeEnum;
    bucket?: InsightBucketEnum;
    insightId?: InsightIdEnum;
  }): Observable<Array<InsightDto>> {

    return this.getTechStackInsights$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InsightDto>>) => r.body as Array<InsightDto>)
    );
  }

  /**
   * Path part for operation getTechStackInsightsByType
   */
  static readonly GetTechStackInsightsByTypePath = '/techstacks/type/{type}/insights';

  /**
   * Get Tech Stack Insights By Template Type.
   *
   * Please, use POST /insights instead
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStackInsightsByType()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTechStackInsightsByType$Response(params: {
    type: string;
    cohort: CohortTypeEnum;
    bucket?: InsightBucketEnum;
    insightId?: InsightIdEnum;
  }): Observable<StrictHttpResponse<Array<InsightDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetTechStackInsightsByTypePath, 'get');
    if (params) {
      rb.path('type', params.type, {});
      rb.query('cohort', params.cohort, {});
      rb.query('bucket', params.bucket, {});
      rb.query('insightId', params.insightId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<InsightDto>>;
      })
    );
  }

  /**
   * Get Tech Stack Insights By Template Type.
   *
   * Please, use POST /insights instead
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStackInsightsByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTechStackInsightsByType(params: {
    type: string;
    cohort: CohortTypeEnum;
    bucket?: InsightBucketEnum;
    insightId?: InsightIdEnum;
  }): Observable<Array<InsightDto>> {

    return this.getTechStackInsightsByType$Response(params).pipe(
      map((r: StrictHttpResponse<Array<InsightDto>>) => r.body as Array<InsightDto>)
    );
  }

  /**
   * Path part for operation addProductsToTechStack
   */
  static readonly AddProductsToTechStackPath = '/techstacks/{id}/products';

  /**
   * Add Products To Tech Stack.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProductsToTechStack()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProductsToTechStack$Response(params: {
    id: string;
    body: Array<AddProductDto>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.AddProductsToTechStackPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Add Products To Tech Stack.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addProductsToTechStack$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProductsToTechStack(params: {
    id: string;
    body: Array<AddProductDto>
  }): Observable<void> {

    return this.addProductsToTechStack$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
